<template>
  <b-overlay
      :show="networks === null"
      rounded="sm"
  >
    <div v-if="networks !== null">
<!--      <user-list-add-new
          :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
          @refetch-data="refreshData"
      />-->

<!-- Table Container Card -->
      <b-card class="mb-0">
        <div class="my-2">
          <b-row class="">
<!--title-->
            <b-col cols="12" md="12">
              <h1>Wallet Network</h1>
            </b-col>
<!-- perPage -->
            <b-col
                cols="12"
                md="3"
            >
              <b-form-group
                  class="mb-2 mt-25"
                  label="Count"
              >
                <v-select
                    v-model="perPage"
                    :clearable="false"
                    :options="perPageOptions"
                    class="per-page-selector w-100 d-inline-block "
                />

              </b-form-group>

            </b-col>
<!-- search -->

            <b-col
                class="mt-25"
                cols="12"
                md="3"
            >
              <b-form-group label="Search">
                <Debouncer @setValue="setQuery"></Debouncer>
              </b-form-group>

            </b-col>
<!--create-->
            <b-col
                cols="12"
                md="3"
                class="align-self-center"
            >
              <b-button
                  class="btn-tour-skip mr-1"
                  variant="primary"
                  @click="$router.push(`/apps/wallet-networks/create-network`)"
              >
                <span class="align-middle">Create</span>

              </b-button>
            </b-col>
          </b-row>
        </div>
<!--table-->
        <b-table
            ref="refNetworkWalletListTable"
            :fields="myTableColumns"
            :items="networks"
            bordered
            class="position-relative"
            empty-text="Nothing found !"
            primary-key="id"
            responsive
            show-empty
            sort-by.sync
            striped
        >

          <template #cell(name)="data">
              <div class="font-weight-bold d-block text-nowrap">
                {{ data.item.name }}
              </div>
          </template>

          <template #cell(symbol)="data">
              <div class="font-weight-bold d-block text-nowrap">
                {{ data.item.symbol }}
              </div>
          </template>

          <template #cell(isActive)="data">
            <b-badge
                v-if="data.item.isActive=== true"
                class="mx-25"
                pill
                variant="primary"
            >
              <span>
                 Active
              </span>

            </b-badge>
            <b-badge
                v-if="data.item.isActive=== false"
                class="mx-25"
                pill
                variant="danger"
            >
              <span>
                InActive
              </span>

            </b-badge>
          </template>

          <template #cell(edit)="data">
            <b-link :to="{ name: 'updateNetworkWallet', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" size="20"/>
            </b-link>
          </template>

          <template #cell(delete)="data">
            <feather-icon v-b-modal.modal-delete @click="selectedNetwork = data.item" icon="TrashIcon" size="20"/>
          </template>
        </b-table>
<!-- Pagination -->
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
                class="d-flex align-items-center justify-content-center "
                cols="12"
                sm="12"
            >

              <b-pagination
                  v-model="currentPage"
                  :per-page="perPage"
                  :total-rows="totalCounts"
                  class="mb-0 mt-1 mt-sm-0"
                  first-number
                  last-number
                  next-class="next-item"
                  prev-class="prev-item"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
    <b-modal
        id="modal-delete"
        cancelTitle="Cancel"
        centered
        ok-title="Delete"

        title="Delete Wallet Network"
        @ok.prevent="deleteNetwork"
    >
      <div class="row">
        <div class="col-md-12">
          <span>Are you sure you want to delete this network ?</span>
        </div>
      </div>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BMedia,
  BModal,
  BOverlay,
  BPagination,
  BRow,
  BTable
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Helper from '@/libs/Helper'
import Debouncer from '@/views/components/debouncer.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {GetWalletNetworks, DeleteWalletNetworks} from '@/libs/Api/Networks'

export default {
  title: 'network list',
  components: {
    BModal,
    Debouncer,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BInputGroup,
    BInputGroupAppend,
    BFormGroup,
    vSelect,
  },

  data() {
    return {
      users: null,
      networks: null,
      currentPage: 1,
      totalCounts: null,
      selectedNetwork: null,
      perPage: 10,
      perState: '',
      baseURL: Helper.baseUrl,
      perPageOptions: [10, 20, 30, 40, 50],
      myTableColumns: [
        {
          key: 'name',
          label: 'network name',
          sortable: true
        },
        {
          key: 'symbol',
          label: 'symbol',
          sortable: true
        },
        {
          key: 'isActive',
          label: 'status',
          sortable: true
        },
        {
          key: 'edit',
          label: 'Edit'
        },
        {
          key: 'delete',
          label: 'Delete'
        },
      ],
      searchQuery: '',
      isAddNewUserSidebarActive: false,
    }
  },

  async created() {
    await this.getNetworks()
  },

  methods: {
    setQuery(data) {
      this.searchQuery = data
      this.getNetworks()
    },
/*    refreshData() {
      this.getNetworks()
    },*/
    async deleteNetwork() {
      let _this = this

      let deleteNetwork = new DeleteWalletNetworks(_this)
      deleteNetwork.setId(_this.selectedNetwork.id)
      await deleteNetwork.fetch(function (content) {
        _this.getNetworks()
        _this.$bvModal.hide("modal-delete")
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            text: 'Wallet Network Deleted Successfully',
            title: `Success`,
            variant: 'success',
          },
        })
      }, function (error) {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            text: error.message,
            title: `error`,
            variant: 'danger',
          },
        })
      })
    },

    async getNetworks() {
      let _this = this
      let data = {
        pageNumber: _this.currentPage,
        count: _this.perPage,
        search: _this.searchQuery,
      }

      let getWalletNetworks = new GetWalletNetworks(_this)
      getWalletNetworks.setParams(data)
      await getWalletNetworks.fetch(function (content) {
        _this.networks = content.data.data
        _this.totalCounts = content.data.totalCount
      }, function (error) {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            text: error.message,
            title: `error`,
            variant: 'danger',
          },
        })
      })
    },
  },

  watch: {
    perPage: function (nv, ov) {
      this.getNetworks()
    },
    currentPage: function (nv, ov) {
      this.getNetworks()
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
